import apiService from '@/api/apiService';

export const updateAssetLiability = async (balanceId, typeId, data) => {
    const url = '/api/admin/asset_liability';
    const requestData = {
        balance_id: balanceId,
        type_id: typeId,
        data: data
    };

    return apiService.POST(url, requestData);
};

export const deleteAssetLiability = async (dataId) => {
    const url = `/api/admin/asset_liability/${dataId}`;
    return apiService.DELETE(url);
};
